<template>
  <div
    class="pt-6 pb-14 bg-white md:pt-[74px] md:pb-0 footer"
    :class="isDark && 'dark'"
  >
    <div
      class="
        md:w-5/6
        mx-auto
        flex flex-col
        md:flex-row
        gap-4
        justify-between
        mb-5
        px-5
        md:px-0
      "
    >
      <div>
        <h6 class="text-monza font-ubuntu-bold">Daihatsu Access</h6>
        <div
          class="
            flex
            items-center
            md:items-baseline
            divide-x divide-black
            md:divide-x-0 md:flex-col
          "
        >
          <div class="text-2xl md:text-3xl pr-2 text-gray-700 font-ubuntu-bold">
            1500898
          </div>
          <a class="pl-2 md:p-0" href="mailto:hotline@daihatsu.astra.co.id"
            >hotline@daihatsu.astra.co.id</a
          >
        </div>
      </div>

      <div class="md:flex md:items-center">
        <!-- <div class=" md:flex md:items-center md:mx-auto"> -->
        <h6
          class="text-azure mb-2 font-ubuntu-bold md:mb-0 md:pr-2 md:text-monza"
        >
          Ikuti Kami
        </h6>
        <div class="flex items-center">
          <a
            v-for="(social, i) in socials"
            :key="i"
            :href="social.link"
            class="pr-2 md:ml-3"
          >
            <img
              :src="isDark ? social.iconLight : social.icon"
              :alt="social.alt"
              height="100%"
              width="100%"
            />
          </a>
        </div>
      </div>
    </div>

    <div
      class="
        grid grid-flow-row
        lg:grid-cols-6
        md:grid-cols-3
        divide-y
        md:divide-y-0 md:mx-auto md:w-5/6 md:gap-4
      "
    >
      <div class="px-5 py-3 text-monza font-ubuntu-bold md:hidden">
        <a href="https://daihatsu.co.id">Home</a>
      </div>
      <div v-for="footer in footers" :key="footer.id" class="md:flex-grow">
        <div
          class="
            px-5
            py-3
            flex
            justify-between
            items-center
            font-ubuntu-bold
            md:px-0 md:pt-0 md:pb-2 md:text-lg
            cursor-pointer
          "
          :class="
            footer.id === activedMenu ? 'bg-monza text-white' : 'text-monza'
          "
          @click="activeMenu(footer.id)"
        >
          <div>{{ footer.name }}</div>
          <svg
            v-if="footer.id !== activedMenu"
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 md:hidden"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 md:hidden"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <expand-transition>
          <div
            v-if="footer.id === activedMenu"
            class="flex flex-col divide-y bg-gray-100 overflow-hidden"
          >
            <div
              v-for="child in footer.children"
              :key="child.to"
              class="px-5 py-3 footer-menu-mobile"
            >
              <a :href="child.to"
                ><span>{{ child.name }}</span></a
              >
            </div>
          </div>
        </expand-transition>
        <ul class="hidden md:block mb-4">
          <li
            v-for="child in footer.children"
            :key="child.to"
            class="hover:underline text-sm leading-6"
          >
            <a :href="child.to"
              ><span>{{ child.name }}</span></a
            >
          </li>
        </ul>
      </div>
    </div>

    <div
      class="
        w-full
        bg-monza
        py-[10px]
        text-[13px] text-center text-white
        md:hidden
      "
    >
      PT Astra Daihatsu Motor © 2022 | Daihatsu Sahabatku
    </div>
    <div class="hidden md:flex pl-16 justify-end items-end copyright">
      <img
        v-if="isDark"
        src="../assets/images/daihatsu_cares_light.png"
        alt="Daihatsu Cares"
        class="mr-4"
      />
      <img
        v-else
        src="../assets/images/daihatsu-cares.png"
        alt="Daihatsu Cares"
        class="mr-4"
      />
      <div class="py-4 px-6 bg-monza rounded-l-full text-white flex-grow">
        All Rights Reserved @ Copyright 2022 PT Astra Daihatsu Motor | Daihatsu
        Sahabatku
      </div>
    </div>
    <div class="hidden md:block w-full p-4 text-center text-xs">
      Website resmi Daihatsu Indonesia. Mobil terbaik, irit, dengan pelayanan
      purna jual terbaik dan bengkel terluas yang tersebar di seluruh Indonesia.
    </div>
  </div>
</template>

<script>
import ExpandTransition from '@/components/lib/ExpandTransition.vue'
import 'unfetch/polyfill'

export default {
  name: 'Footer',
  components: { ExpandTransition },
  props: {
    isDark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      socials: [
        {
          icon: require('../assets/images/icon-footer/icon-ig.png'),
          iconLight: require('../assets/images/icon-footer/icon-ig-light.png'),
          link: 'https://www.instagram.com/daihatsuind',
          alt: 'Link Instagram Daihatsu',
        },
        {
          icon: require('../assets/images/icon-footer/icon-fb.png'),
          iconLight: require('../assets/images/icon-footer/icon-fb-light.png'),
          link: 'https://www.facebook.com/daihatsuindonesia/',
          alt: 'Link Facebook Daihatsu',
        },
        {
          icon: require('../assets/images/icon-footer/icon-twitter.png'),
          iconLight: require('../assets/images/icon-footer/icon-twitter-light.png'),
          link: 'https://twitter.com/daihatsuind',
          alt: 'Link Twitter Daihatsu',
        },
        {
          icon: require('../assets/images/icon-footer/icon-yt.png'),
          iconLight: require('../assets/images/icon-footer/icon-yt-light.png'),
          link: 'https://youtube.com/daihatsusahabatku',
          alt: 'Link Youtube Daihatsu',
        },
        {
          icon: require('../assets/images/icon-footer/icon-tiktok.png'),
          iconLight: require('../assets/images/icon-footer/icon-tiktok.png'),
          link: 'https://www.tiktok.com/@daihatsuind',
          alt: 'Link Tiktok',
        },
      ],
      products: [],
      activedMenu: null,
    }
  },
  computed: {
    footers() {
      return [
        {
          id: 'footers-accordion-2',
          name: 'Profile',
          children: [
            {
              name: 'About Us',
              to: 'https://daihatsu.co.id/profile/about-us/',
            },
            {
              name: 'Awards',
              to: 'https://daihatsu.co.id/profile/award/',
            },
            {
              name: 'E-Magz',
              to: 'https://daihatsu.co.id/profile/e-magazine/',
            },
            {
              name: 'Brosur',
              to: 'https://daihatsu.co.id/profile/brosur/',
            },
            {
              name: 'CSR',
              to: 'https://daihatsu.co.id/profile/csr/',
            },
            {
              name: 'Contact Us',
              to: 'https://daihatsu.co.id/contact-us/',
            },
          ],
        },
        {
          id: 'footers-accordion-3',
          name: 'Product',
          children:
            this.products.length > 0
              ? this.products.map((product) => ({
                  name: product.name,
                  to: `https://daihatsu.co.id/product/${product.slug}`,
                }))
              : [],
        },
        {
          id: 'footers-accordion-4',
          name: 'Shopping Tools',
          children: [
            {
              name: 'Price List',
              to: 'https://daihatsu.co.id/price-list/',
            },
            {
              name: 'Credit Simulation',
              to: 'https://daihatsu.co.id/simulasi-kredit/',
            },
            {
              name: 'Insurance Simulation',
              to: 'https://www.asuransiastra.com/garda-oto/Daihatsu-quote',
              external: true,
            },
            {
              name: 'Promo',
              to: 'https://daihatsu.co.id/promo/',
            },
            {
              name: 'Find Dealer',
              to: 'https://daihatsu.co.id/shopping/dealer/',
            },
            {
              name: 'Request Quotes',
              to: 'https://daihatsu.co.id/request-quotes/',
            },
            {
              name: 'Download Brosur',
              to: 'https://daihatsu.co.id/profile/brosur/',
            },
          ],
        },
        {
          id: 'footers-accordion-5',
          name: 'Ownership',
          children: [
            {
              name: 'Daihatsu Event',
              to: 'https://daihatsu.co.id/tips-and-event/event/',
            },
            {
              name: 'Daihatsu News',
              to: 'https://daihatsu.co.id/program-and-event/press-release/',
            },
            {
              name: 'Social Media',
              to: 'https://daihatsu.co.id/program-and-event/social-buzz/',
            },
            {
              name: 'Daihatsu Club',
              to: 'https://daihatsu.co.id/klub/',
            },
          ],
        },
        {
          id: 'footers-accordion-6',
          name: 'After Sales',
          children: [
            {
              name: 'Service Menu',
              to: 'https://daihatsu.co.id/ownership/service-menu/',
            },
            {
              name: 'Owners Manual',
              to: 'https://daihatsu.co.id/ownership/owners-manual/',
            },
            {
              name: 'Daihatsu Mobile Apps',
              to: 'https://daihatsu.co.id/ownership/mobile-apps/',
            },
            {
              name: 'Daihatsu Mobile Service',
              to: 'https://daihatsu.co.id/ownership/mobile-services/',
            },
            {
              name: 'Daihatsu We Care',
              to: 'https://daihatsu.co.id/ownership/daihatsu-cares/',
            },
            {
              name: 'Facilities',
              to: 'https://daihatsu.co.id/ownership/facilities/',
            },
            {
              name: 'Booking Service',
              to: 'https://daihatsu.co.id/ownership/booking-service/',
            },
            {
              name: 'Trade In',
              to: 'https://daihatsu.co.id/ownership/used-car/',
            },
            {
              name: 'Daihatsu Sparepart',
              to: 'https://daihatsu-sparepart.com/',
            },
            {
              name: 'Daihatsu Genuine Oil',
              to: '#',
            },
            {
              name: 'Recall Program',
              to: 'https://recall.daihatsu.co.id',
            },
          ],
        },
        {
          id: 'footers-accordion-7',
          name: 'Daihatsu Fleet',
          children: [
            {
              name: 'Special Order Request',
              to: 'https://daihatsu.co.id/customer-fleet/',
            },
          ],
        },
      ]
    },
  },
  created() {
    this.getProducts()
  },
  methods: {
    async getProducts() {
      try {
        const response = await fetch(
          'https://cms.daihatsu.co.id/api/list_product'
        )
        const {
          data: { product },
        } = await response.json()
        this.products = product
      } catch ({ response }) {
        console.log(response.data)
      }
    },
    activeMenu(id) {
      if (this.activedMenu === id) {
        this.activedMenu = null
        return
      }
      this.activedMenu = id
    },
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;500&display=swap');
</style>

<style scoped lang="scss">
@import url('../assets/scss/tailwind.scss');

.footer {
  font-family: 'Ubuntu';

  &.dark {
    background-color: #000;
    color: #fff;

    .text-monza,
    .md\:text-monza,
    .text-gray-700 {
      color: #fff;
    }

    .footer-menu-mobile a {
      color: #333;
    }

    .bg-monza {
      background-color: #000;
    }

    .title,
    .menu a,
    .hotline .email {
      color: #fff;
    }

    .copyright {
      > div {
        background-color: #fff;
        color: #000;
      }
    }
  }
}
</style>
